<!-- <div fxLayout="row" fxLayoutAlign="start stretch">
    <div fxFlex="69" fxLayout="row" fxLayoutAlign="start center" class="co-owner__title container__tooltip">
        <div fxLayoutAlign="start center" >
            <span>{{(index === 0 ? 'CO_OWNER_DATA_SECTION.headerOneCoOwner' : 'CO_OWNER_DATA_SECTION.headerNextCoOwner')| translate }}</span>
        </div>
    </div>
</div> -->

<div class="dropdown-container__title dropdown-container__tooltip dropdown-container__subtitle">
    <span>{{(index === 0 ? 'CO_OWNER_DATA_SECTION.headerOneCoOwner' : 'CO_OWNER_DATA_SECTION.headerNextCoOwner')| translate }}</span>
</div>

<div class="form coowner-data">
    <app-section-data-presentation *ngIf="previewMode"
                                   [formGroup]="coOwnerFormGroup"
                                   [parentSection]="parentSection"
                                   [formConfig]="coOwnerFormConfig"
                                   [displayedFields]="dataPresentationFields">
    </app-section-data-presentation>

    <div class="col" [ngClass]="{'col-preview-mode': previewMode}">
        <div *ngIf="canFieldDisplayed(consts.FIRST_NAME)" class="section__component col-50">
            <app-text-field
                    [errorsMap]="coOwnerFormService.errorsMap"
                    [control]="coOwnerFormGroup.controls[consts.FIRST_NAME]"
                    [fieldConfig]="coOwnerFormService.fieldConfig(consts.FIRST_NAME, coOwnerFormConfig)"
                    [context]="coOwnerFormConfig.formKey"
                    [customMetrics]="customMetricsData(index)"
                    [isDirtyBean]="isDirtyBean && isDirtyBean[getCoOwnerKeyWithIndex(consts.FIRST_NAME, index)]"
                    (markAsDirty)="markAsDirty($event)"
            >
            </app-text-field>
        </div>

        <div *ngIf="canFieldDisplayed(consts.LAST_NAME)" class="section__component col-50">
            <app-text-field
                    [errorsMap]="coOwnerFormService.errorsMap"
                    [control]="coOwnerFormGroup.controls[consts.LAST_NAME]"
                    [fieldConfig]="coOwnerFormService.fieldConfig(consts.LAST_NAME, coOwnerFormConfig)"
                    [context]="coOwnerFormConfig.formKey"
                    [customMetrics]="customMetricsData(index)"
                    [isDirtyBean]="isDirtyBean && isDirtyBean[getCoOwnerKeyWithIndex(consts.LAST_NAME, index)]"
                    (markAsDirty)="markAsDirty($event)"
            >
            </app-text-field>
        </div>

        <div *ngIf="canFieldDisplayed(consts.PESEL)" class="section__component col-50">
            <app-text-field [errorsMap]="coOwnerFormService.errorsMap"
                            [control]="coOwnerFormGroup.controls[consts.PESEL]"
                            [fieldConfig]="coOwnerFormService.fieldConfig(consts.PESEL, coOwnerFormConfig)"
                            [context]="coOwnerFormConfig.formKey"
                            [customMetrics]="customMetricsData(index)"
                            [isDirtyBean]="isDirtyBean && isDirtyBean[getCoOwnerKeyWithIndex(consts.PESEL, index)]"
                            (markAsDirty)="markAsDirty($event)"
            >
            </app-text-field>
        </div>

        <div *ngIf="canFieldDisplayed(consts.POSTAL_CODE)" class="section__component col-50">
            <app-text-field [errorsMap]="coOwnerFormService.errorsMap"
                            [control]="coOwnerFormGroup.controls[consts.POSTAL_CODE]"
                            [fieldConfig]="coOwnerFormService.fieldConfig(consts.POSTAL_CODE, coOwnerFormConfig)"
                            [context]="coOwnerFormConfig.formKey"
                            [customMetrics]="customMetricsData(index)"
                            [isDirtyBean]="isDirtyBean && isDirtyBean[getCoOwnerKeyWithIndex(consts.POSTAL_CODE, index)]"
                            (markAsDirty)="markAsDirty($event)"
            >
            </app-text-field>
        </div>

        <div *ngIf="canFieldDisplayed(consts.DRIVING_LICENSE_ISSUE_YEAR)" class="section__component col-50">
            <app-material-year-picker #drivingLicenseIssueYearField
                                     [errorsMap]="coOwnerFormService.errorsMap"
                                     [control]="coOwnerFormGroup.controls[consts.DRIVING_LICENSE_ISSUE_YEAR]"
                                     [fieldConfig]="coOwnerFormService.fieldConfig(consts.DRIVING_LICENSE_ISSUE_YEAR, coOwnerFormConfig)"
                                     [context]="coOwnerFormConfig.formKey"
                                     [customMetrics]="customMetricsData(index)"
                                     [isDirtyBean]="isDirtyBean && isDirtyBean[getCoOwnerKeyWithIndex(consts.DRIVING_LICENSE_ISSUE_YEAR, index)]"
                                     (markAsDirty)="markAsDirty($event)"
            >
            </app-material-year-picker>
        </div>

        <div class="section__component col-50 coowner-data__no-driving-license"
             *ngIf="noDrivingLicenseAvailable && canFieldDisplayed(consts.NO_DRIVING_LICENSE)">
            <app-checkbox
                    [errorsMap]="coOwnerFormService.errorsMap"
                    [control]="coOwnerFormGroup.controls[consts.NO_DRIVING_LICENSE]"
                    [fieldConfig]="coOwnerFormService.fieldConfig(consts.NO_DRIVING_LICENSE, coOwnerFormConfig)"
                    [context]="coOwnerFormConfig.formKey"
                    [customMetrics]="customMetricsData(index)"
                    [isDirtyBean]="isDirtyBean && isDirtyBean[getCoOwnerKeyWithIndex(consts.NO_DRIVING_LICENSE, index)]"
                    (markAsDirty)="markAsDirty($event)"
            >
            </app-checkbox>
        </div>

        <div class="section__component col-50"
                 *ngIf="drivingLicenseIssueMonthCollected && canFieldDisplayed(consts.DRIVING_LICENSE_ISSUE_MONTH)">
            <app-select
                    [errorsMap]="coOwnerFormService.errorsMap"
                    [control]="coOwnerFormGroup.controls[consts.DRIVING_LICENSE_ISSUE_MONTH]"
                    [fieldConfig]="coOwnerFormService.fieldConfig(consts.DRIVING_LICENSE_ISSUE_MONTH, coOwnerFormConfig)"
                    [context]="coOwnerFormConfig.formKey"
                    [customMetrics]="customMetricsData(index)"
                    [isDirtyBean]="isDirtyBean && isDirtyBean[getCoOwnerKeyWithIndex(consts.DRIVING_LICENSE_ISSUE_MONTH, index)]"
                    (markAsDirty)="markAsDirty($event)"
            >
            </app-select>
        </div>
    </div>
</div>

